// Marchi Spotify / Strava — forme tipo Simple Icons (uso in UI integrazioni).

export function SpotifyMark({ size = 24, color = '#FFFFFF', title = 'Spotify', ...rest }) {
  return (
    <svg role="img" aria-label={title} width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <title>{title}</title>
      <path
        fill={color}
        d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.301-3.239-1.98-8.159-2.58-11.939-1.381-.479.12-1.02-.12-1.141-.601-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.180-.539.18-1.199.720-1.379 4.261-1.081 11.561-.840 14.941 1.38.539.361.659 1.081.42 1.621-.24.54-.84.72-1.381.42z"
      />
    </svg>
  )
}

export function StravaMark({ size = 24, color = '#FFFFFF', title = 'Strava', ...rest }) {
  return (
    <svg role="img" aria-label={title} width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <title>{title}</title>
      <path
        fill={color}
        d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169"
      />
    </svg>
  )
}
